import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=8a2266ca&scoped=true"
import script from "./ProductAdd.vue?vue&type=script&lang=js"
export * from "./ProductAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&id=8a2266ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2266ca",
  null
  
)

export default component.exports